import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AuthService } from 'app/modules/auth/auth.service';

@Component({
  selector: 'app-account-status-dialog',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './account-status-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountStatusDialogComponent {
  readonly dialogRef = inject(MatDialogRef<AccountStatusDialogComponent>);
  private authService = inject(AuthService);
  private router = inject(Router);

  loading: number = 0;

  logout(): void {
    this.loading++;
    this.authService.logout().subscribe({
      next: () => {
        this.authService.profile.set(null);
        this.dialogRef.close();
        this.router.navigate(['/login']);
        this.loading--;
      },
      error: () => {
        this.loading--;
      },
    });
  }
}
